import Model from 'src/app/core/models/model';

export default class SyncModel extends Model {
	role: Array<IRole>;
	routeIds: Array<IRouteID>;

	constructor() {
		super();
		this.routeIds = new Array();
		this.role = new Array();
	}
}

//////////////////////////////
//IRole
//////////////////////////////
export class IRole {
	name: string;

	constructor() { }
}

//////////////////////////////
//IRouteID
//////////////////////////////
export class IRouteID {
	routeID: string;
	methods: Array<string>;

	constructor() { }
}